import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Experience from "@/components/Experience";
import Productions from "@/components/Productions";
import Showreel from "@/components/Showreel";
import Skills from "@/components/Skills";
import Certifications from "@/components/Certifications";
import Testimonial from "@/components/Testimonial";
import FinalCTA from "@/components/FinalCTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ anchors: true, lerp: 0.1 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] font-body text-neutral-100 antialiased">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Experience />
        <Productions />
        <Showreel />
        <Skills />
        <Certifications />
        <Testimonial />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
